import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_winners-pro/artifacts/wuxtjwav_FBA-02.png" 
                alt="FBA Logo" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Promoting integrity and ethical practices in the foreign exchange market. 
              Our mission is to establish global standards and foster trust among market participants.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/mission" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  Mission & Values
                </Link>
              </li>
              <li>
                <Link to="/awards" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  Awards
                </Link>
              </li>
              <li>
                <Link to="/code" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  The Code
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-cyan-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">New York, USA</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={16} className="text-cyan-400 mt-1 flex-shrink-0" />
                <a href="mailto:info@forexbrokers.org" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  info@forexbrokers.org
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={16} className="text-cyan-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">+1 (555) 123-4567</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Forex Brokers Association. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;